import React, { useEffect, useMemo, memo, lazy, Suspense } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import ConsumerConfirm from './consumer-confirm/ConsumerConfirm';
import BootScreen from '../components/boot-screen/BootScreen';
import { PROJECT_TYPES, PROJECT_VARIANTS } from '../constants';
import { getServerUrl } from '../redux/security/securityActions';
import { ProjectProvider } from '../context/ProjectContext';

import './ConsumerPage.scss';

const SonarDashboard = lazy(() => import('./sonar-dashboard/SonarDashboard'));
const Scout = lazy(() => import('./scout/Scout'));
const Genie = lazy(() => import('./genie/Genie'));
const Resonance = lazy(() => import('./resonance/Resonance'));
const GenieGo = lazy(() => import('./genie-go/GenieGo'));
const Id8 = lazy(() => import('./id8/Id8'));
const Activ8 = lazy(() => import('./activ8/Activ8'));

const ConsumerPage = () => {
  const dispatch = useDispatch();
  const pathname = useLocation().pathname;

  const projectType = pathname.split('/')[1];
  const isConfirmed = useSelector((state) => state.consumer.isConfirmed);

  const projectTypeUpper = useMemo(() => projectType.toUpperCase(), [projectType]);

  useEffect(() => {
    dispatch(getServerUrl());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {!isConfirmed ? <ConsumerConfirm /> : null}

      <Suspense fallback={<BootScreen />}>
        {projectTypeUpper === PROJECT_TYPES.SONAR && isConfirmed ? (
          <ProjectProvider projectVariant={PROJECT_VARIANTS.CONSUMER} projectType={PROJECT_TYPES.SONAR}>
            <SonarDashboard />
          </ProjectProvider>
        ) : null}
        {projectTypeUpper === PROJECT_TYPES.SCOUTV2 && isConfirmed ? (
          <ProjectProvider projectVariant={PROJECT_VARIANTS.CONSUMER} projectType={PROJECT_TYPES.SCOUTV2}>
            <Scout />
          </ProjectProvider>
        ) : null}
        {projectTypeUpper === PROJECT_TYPES.GENIE && isConfirmed ? (
          <ProjectProvider projectVariant={PROJECT_VARIANTS.CONSUMER} projectType={PROJECT_TYPES.GENIE}>
            <Genie />
          </ProjectProvider>
        ) : null}
        {projectTypeUpper === PROJECT_TYPES.RESONANCE && isConfirmed ? <Resonance /> : null}
        {projectTypeUpper === PROJECT_TYPES.GENIE_GO && isConfirmed ? (
          <ProjectProvider projectVariant={PROJECT_VARIANTS.CONSUMER} projectType={PROJECT_TYPES.GENIE_GO}>
            <GenieGo />
          </ProjectProvider>
        ) : null}
        {projectTypeUpper === PROJECT_TYPES.ACTIV8 && isConfirmed ? <Activ8 /> : null}
        {projectTypeUpper === PROJECT_TYPES.ID8 && isConfirmed ? (
          <ProjectProvider projectVariant={PROJECT_VARIANTS.CONSUMER} projectType={PROJECT_TYPES.ID8}>
            <Id8 />
          </ProjectProvider>
        ) : null}
      </Suspense>
    </>
  );
};

export default memo(ConsumerPage);
